import { AxiosError } from 'axios'
import { LocationSetupContract } from 'models'
import {
    CLEAR_INSTALLATION_PIN,
    FETCH_LOCATION_SETUP_FAILED,
    FETCH_LOCATION_SETUP_START,
    FETCH_LOCATION_SETUP_SUCCESS,
    GET_INSTALLATION_PIN_START,
    GET_INSTALLATION_PIN_SUCCESS,
    GET_INSTALLATION_PIN_FAILED,
} from 'store/actions/locationSetup.action'
import { IAction } from 'types/storeTypes'

interface IState {
    locationSetups: LocationSetupContract[]
    installLocation?: LocationSetupContract
    installError?: AxiosError
    generatingPin: boolean
    loading: boolean
    error?: AxiosError
}

const initialState: IState = {
    locationSetups: [],
    loading: false,
    generatingPin: false,
}

function locationSetupReducer(
    state: IState = initialState,
    action: IAction,
): IState {
    const { payload, type } = action

    switch (type) {
        case FETCH_LOCATION_SETUP_START:
            return { ...state, loading: true }
        case FETCH_LOCATION_SETUP_SUCCESS:
            return { ...state, loading: false, locationSetups: payload }
        case FETCH_LOCATION_SETUP_FAILED:
            return { ...state, loading: false, error: payload }
        case GET_INSTALLATION_PIN_START:
            return {
                ...state,
                generatingPin: true,
            }
        case GET_INSTALLATION_PIN_SUCCESS:
            return {
                ...state,
                generatingPin: false,
                installLocation: payload,
            }
        case GET_INSTALLATION_PIN_FAILED:
            return {
                ...state,
                generatingPin: false,
                installError: payload,
            }
        case CLEAR_INSTALLATION_PIN:
            return {
                ...state,
                installLocation: undefined,
            }
        default:
            return state
    }
}

export default locationSetupReducer
